import { hashQueryKey, useQuery, UseQueryOptions } from "@tanstack/react-query";
import { refreshToken } from "@services/auth";

export function useRefreshToken(options?: UseQueryOptions) {
  return useQuery({
    queryKey: ["refreshToken"],
    queryFn: refreshToken,
    // The session is the same in every scheme: keyed by scheme (App.tsx), a
    // switch would refetch it and AppLayout would show its sign-in spinner.
    queryKeyHashFn: hashQueryKey,
    ...options,
  });
}
